import React from "react";
import { Link, useMatch } from "react-router-dom";
import { ListItemText, ListItemIcon, ListItemButton } from "@mui/material";

interface Props {
  to: string;
  label: string;
  secondary: string;
  icon?: React.ReactNode;
}

export const LinkListItem = ({ to, icon, label, secondary }: Props) => {
  const isMatched = useMatch(to);

  return (
    <ListItemButton component={Link} to={to}>
      {icon && <ListItemIcon>{icon}</ListItemIcon>}
      <ListItemText
        primary={label}
        secondary={secondary}
        primaryTypographyProps={{
          color: Boolean(isMatched) ? "#0288d1" : "white",
        }}
      />
    </ListItemButton>
  );
};
